import GetCategoryByIdRequestModelBase from '../_generated/modelBases/get-category-by-id-request-model-base';

export default class GetCategoryByIdRequestModel extends GetCategoryByIdRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
